<div class="checkbox" [class.padded]="padded">
  <mat-slide-toggle [color]="color" [ngModel]="value" [disabled]="disabled" (blur)="onTouch()" (ngModelChange)="value = $event">
    {{ labelKey | locLabel }}
  </mat-slide-toggle>
</div>
